const getOrderLineModifiers2 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine && indexOrderLine.Modifiers) {
      return typeof indexOrderLine.Modifiers === 'object'
        ? indexOrderLine.Modifiers[1] : indexOrderLine.Modifiers.slice(2, 4);
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => (typeof item.Modifiers === 'object'
      ? item.Modifiers[1] : item.Modifiers.slice(2, 4)).join(', '))
    : null;
};

export default getOrderLineModifiers2;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineModifiers2.js